









































































import Vue from 'vue'
import {
  StreamRepository,
  fetchStreamRecorderTypes,
  downloadStreamAudioSample,
  downloadStreamVideoSample,
} from '@/core/api/streams'
import { CRUDMixinFactory } from '@/core/crud-mixin'
import { EventBus } from '@/core/events'

const CRUDMixin = CRUDMixinFactory(new StreamRepository(), EventBus)

export default Vue.extend({
  data: () => ({
    downloading: false,
    item: null as any,
    recorderTypes: [],
    errors: {},
  }),
  async mounted() {
    const id = this.$route.params.id
    this.item = await this.getOrCreate(id, {})
    this.recorderTypes = await fetchStreamRecorderTypes()
  },
  methods: {
    async getOrCreate(id, defaults) {
      if (id == null) {
        return defaults
      }

      return this.fetch(id).then(item => {
        return item
      })
    },
    onDeleteClick() {
      this.delete(this.item).then(() => {
        this.goBack()
      })
    },
    onSaveClick() {
      this.save(this.item).catch(error => {
        this.errors = error.response?.data || {}
      })
    },
    onDownloadAudioClick() {
      this.downloading = true
      downloadStreamAudioSample(this.item['id']).finally(() => {
        this.downloading = false
      })
    },
    onDownloadVideoClick() {
      this.downloading = true
      downloadStreamVideoSample(this.item['id']).finally(() => {
        this.downloading = false
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    ...CRUDMixin,
  },
})
